<div
  class="relative rounded-sm border border-gray-200 before:block before:pt-[100%]">
  <div class="absolute inset-0 flex items-center justify-center">
    <ng-content />
  </div>
</div>
